import React, { useEffect, useState } from "react";
import { useFormikContext } from "formik";
import FormikInput from "../../Formik/FormikInput";
import styled from "styled-components";
import { useLanguage } from "../../LangTranslation/LanguageContext";
// import useListOptions from "../../../CustomHooks/useListOptions";
import FormikSelect from "../../Formik/FormikSelect";
import {
  SELLER_GROUP_LIST,
  SELLER_GROUP_TAXES_LIST,
} from "../../../utilities/constants";
// import { findAndAddOption } from "../../../utilities/findAndAddOption";
import { useSession } from "../../../authentications/SessionContext";
import { callButtonGeneral } from "../../../DataApi/generalApis/callButtonGeneral";
import { closeSnackbar, enqueueSnackbar } from "notistack";

const FormContainer = styled.div`
  width: 100%;
  height: 100%;
  margin-top: 20px;

  .form-control {
    display: block;
    width: 100%;
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    height: 56px !important;
    font-weight: 400;
    line-height: 1.5;
    color: #4e5d78 !important;
    background-color: #f5f5f5;
    background-clip: padding-box;
    border: 1px solid #cbcbcb !important;
    border-radius: 13px !important;
  }
  *:focus {
    box-shadow: none !important;
  }
  .sales_heading {
    font-family: "Inter";
    font-weight: 600;
    font-size: 20px;
    color: "#4E5D78";
  }
  input[type="checkbox"] {
    width: 16px;
    height: 15px;
    accent-color: #ff5837;
  }
`;

const VtexIntegration = ({
  disabled,
  isVtexInvitationConnected,
  refetchData,
}) => {
  const { setFieldValue, values } = useFormikContext();
  const { language, translations } = useLanguage();
  const { sessionInfo } = useSession();
  const { company_id, context } = sessionInfo;
  const t = translations[language];
  context["allowed_company_ids"] = [company_id];
  const [radioStatus, setRadioStatus] = useState("Pending");
  const [loading, setLoading] = useState(false);

  const handleStatusBtnsClick = async (method) => {
    if (loading) return;
    setLoading(true);
    let snackbarKey;
    if (method === "setup_vtex") {
      snackbarKey = enqueueSnackbar("Processing VTEX setup request...", {
        variant: "warning",
        persist: true,
      });
    }
    try {
      let response = await callButtonGeneral({
        company_id,
        method: method,
        model: "res.company",
        args: [[values.id]],
        context,
      });
      if (response?.result) {
        if (method === "setup_vtex") {
          closeSnackbar(snackbarKey);
        }
        if (response?.result?.code == 200 && response?.result?.val == true) {
          enqueueSnackbar(response?.result?.msg, {
            variant: "success",
            persist: false,
          });
          // console.log(`response of ${method}`, response, values.vtex_status);
          if (method === "ApproveVtex") {
            setRadioStatus("Approved");
          } else if (method === "RejectVtex") {
            setRadioStatus("Rejected");
          } else if (method === "ResetToPending") {
            setRadioStatus("Pending");
          }
          refetchData();
        } else {
          enqueueSnackbar(response?.result?.msg, {
            variant: "warning",
            persist: false,
          });
        }
      } else {
        enqueueSnackbar("Action failed!", {
          variant: "error",
          persist: false,
        });
      }
    } catch (error) {
      console.error("API error:", error);
    } finally {
      setLoading(false);
    }
  };
  function capitalize(str) {
    if (!str) return "";
    return str.charAt(0).toUpperCase() + str.slice(1);
  }
  useEffect(() => {
    // console.log("vtex status", capitalize(values.vtex_status));
    setRadioStatus(capitalize(values.vtex_status));
  }, []);

  return (
    <div>
      <div className="d-flex flex-md-row flex-column-reverse justify-content-between align-items-center pe-2 gap-2">
        <div className="d-flex flex-column align-items-center justify-content-center">
          <h6 className="fw-bold text-secondary text-decoration-underline">
            <small>Action Buttons:</small>
          </h6>
          <div className="d-flex justify-content-center align-items-center gap-1">
            <button
              disabled={disabled || false}
              id="ApproveVtex"
              type="button"
              className="btn btn-sm btn-primary badge rounded-pill"
              onClick={() => handleStatusBtnsClick("ApproveVtex")}
            >
              Approve
            </button>
            <button
              disabled={disabled || false}
              id="ResetToPending"
              type="button"
              className="btn btn-sm btn-secondary badge rounded-pill"
              onClick={() => handleStatusBtnsClick("ResetToPending")}
            >
              Reset
            </button>
            <button
              disabled={disabled || false}
              id="RejectVtex"
              type="button"
              className="btn btn-sm btn-danger badge rounded-pill"
              onClick={() => handleStatusBtnsClick("RejectVtex")}
            >
              Reject
            </button>
            {values.vtex_appkey &&
              values.vtex_api_token &&
              !isVtexInvitationConnected && (
                <button
                  disabled={disabled || false}
                  id="setup_vtex"
                  type="button"
                  className="btn btn-sm btn-info badge rounded-pill"
                  onClick={() => handleStatusBtnsClick("setup_vtex")}
                >
                  Setup VTEX
                </button>
              )}
          </div>
        </div>
        <div className="d-flex flex-column align-items-center justify-content-center">
          <h6 className="fw-bold text-secondary text-decoration-underline">
            <small>Status:</small>
          </h6>
          <div
            className="btn-group gap-2"
            role="group"
            aria-label="Basic radio toggle button group"
          >
            <input
              type="radio"
              className="btn-check"
              name="Pending"
              id="Pending"
              autoComplete="off"
              checked={radioStatus === "Pending"}
              readOnly
            />
            <label
              className="btn btn-outline-primary  badge rounded-pill"
              htmlFor="Pending"
            >
              Pending
            </label>

            <input
              type="radio"
              className="btn-check"
              name="Approved"
              id="Approved"
              autoComplete="off"
              checked={radioStatus === "Approved"}
              readOnly
            />
            <label
              className="btn btn-outline-primary  badge rounded-pill"
              htmlFor="Approved"
            >
              Approved
            </label>

            <input
              type="radio"
              className="btn-check"
              name="Rejected"
              id="Rejected"
              autoComplete="off"
              checked={radioStatus === "Rejected"}
              readOnly
            />
            <label
              className="btn btn-outline-primary  badge rounded-pill"
              htmlFor="Rejected"
            >
              Rejected
            </label>
          </div>
        </div>
      </div>
      <FormContainer className="row g-3 px-2">
        <div className="col-md-12">
          <FormikInput
            disabled={true}
            type="checkbox"
            name="is_vtex"
            label={t["Is VTEX"]}
          />
        </div>
        <div className="col-md-6">
          <FormikInput
            disabled={true}
            type="text"
            name="VtexInvitationId"
            label={t["Vtex Invitation Id"]}
          />
        </div>
        <div className="col-md-6">
          <FormikInput
            disabled={true}
            type="text"
            name="vtex_invitation"
            label={t["VTEX Invitation"]}
          />
        </div>
        <div className="col-md-6">
          <FormikInput
            disabled={disabled || false}
            type="text"
            name="vtex_appkey"
            label={t["VTEX App Key"]}
          />
        </div>
        <div className="col-md-6">
          <FormikInput
            disabled={disabled || false}
            type="text"
            name="vtex_api_token"
            label={t["VTEX API Token"]}
          />
        </div>
        <div className="col-md-6">
          <FormikInput
            disabled={true}
            type="text"
            name="VtexAccountName"
            label={t["VTEX Account Name"]}
          />
        </div>
        <div className="col-md-6">
          <FormikInput
            disabled={true}
            type="text"
            name="VtexWarehouse"
            label={t["Warehouse Status"]}
          />
        </div>
        <div className="col-md-6">
          <FormikSelect
            disabled={disabled || false}
            options={SELLER_GROUP_LIST}
            name="vtexSellerGroup"
            label={t["Seller Group Delivery"]}
          />
        </div>
        <div className="col-md-6">
          <FormikSelect
            disabled={disabled || false}
            options={SELLER_GROUP_TAXES_LIST}
            name="vtexSellerGroupTax"
            label={t["Seller Group Taxes"]}
          />
        </div>
      </FormContainer>
    </div>
  );
};

export default VtexIntegration;
